(() => {
  if (customElements.get('checkout-revenue')) return;
  customElements.define('checkout-revenue', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-revenue-item], [data-revenue-dot], [data-revenue-line]').forEach(element => element.setAttribute('data-visible', ''));
      const values = { total: '$6.20', gain: '+$1.70', percent: '+37.8%' };
      Object.entries(values).forEach(([name, value]) => {
        const element = this.querySelector(`[data-revenue-${name}]`);
        if (element) element.textContent = value;
      });
      this.setAttribute('data-played', '');
    }
  });
})();
